/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 签到
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  activityId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/sign-in/${activityId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
